export default {
    it: {
      
    },
    en: {
     
    }
}